import {MapView} from '../MapView'
import {useContext, useMemo, useState} from 'react'
import {DataContext} from '../../context/DataContext'
import {getLayer, getLayers} from '../MapLayers/Layer'
import {FilterContext} from '../../context/FilterContext'
import {AllGeoJSON} from '@turf/turf'
import {Legenda} from '../Legenda'
import CheckServices from '../CheckServices'
import {HeaderPerformance} from '../Common/HeaderPerformance'
import CheckServicesInfra from '../CheckServicesInfra'
import {MakerServicesInfra} from '../CheckServicesInfra/MakerServicesInfra'
import {exportImage} from '../../../../utils/ExportPdf'

type Props = {
  label?: string
}

const layerNames = ['trilhos_urbanos_trajetos', 'trilhos_urbanos_estacoes']

export function PerformanceServicosInfra({label}: Props) {
  const {data, cacheResult} = useContext(DataContext)
  const {geometriaSelecionada, endereco} = useContext(FilterContext)
  const [visibleLayers, setVisibleLayers] = useState({
    trilhos_urbanos_trajetos: true,
    trilhos_urbanos_estacoes: true,
  })
  const layerLabels = useMemo(() => {
    const labels = {}
    layerNames.forEach((name) => {
      const layerConfig = getLayer(name)
      labels[name] =
        layerConfig?.name ||
        layerConfig?.name ||
        (name === 'trilhos_urbanos_trajetos' ? 'Trilhos (trajetos)' : 'Trilhos (estacoes)')
    })
    return labels
  }, [])

  const json = geometriaSelecionada?.geometry as AllGeoJSON
  const layersList = json ? getLayers(layerNames, json) : []
  const layersVisible = useMemo(() => {
    return layersList.filter((layer) => {
      const id = layer?.id || layer?.props?.id
      if (id === 'trilhos_urbanos_trajetos') {
        return visibleLayers.trilhos_urbanos_trajetos
      }
      if (id === 'trilhos_urbanos_estacoes') {
        return visibleLayers.trilhos_urbanos_estacoes
      }
      return true
    })
  }, [layersList, visibleLayers])
  // console.log('layersList')
  // console.log(layersList)
  // const layerConfig = getLayer('view_ibge_explorer_renda_mensal_domiciliar')
  let center = {
    lat: -46.6,
    lng: -23.6,
  }
  if (endereco) {
    center = {lat: endereco.latitude, lng: endereco.longitude}
  }
  // const {cacheResult, setCacheResult} = useContext(DataContext)
  if (!data || !geometriaSelecionada || !json) {
    return <>Carregando...</>
  }
  const markers = (cacheResult.servicosInfraestrtutura || []).filter((item) => item.showOnMap)

  return (
    <>
      <div className=' d-flex flex-column justify-content-start p-10'>
        <HeaderPerformance titulo={'Sóciodemográfico...'}></HeaderPerformance>
        <div className='content pt-5'>
          <div className='row'>
            <div className='col-12'>
              <div className='card bgi-no-repeat card-xl-stretch mb-xl-8 border-2 box-performance'>
                <div className='map-painel d-flex w-100'>
                  <div className='mapa col-6'>
                    <div className='print-map-only printable-map' id='servicos-infra-map'>
                      <MapView
                        data={data}
                        layer={layersVisible}
                        height={'650px'}
                        zoom={15}
                        center={center}
                        geometria={geometriaSelecionada}
                      >
                        <MakerServicesInfra marker={markers}></MakerServicesInfra>
                        {/* <Legenda
                        style={layerConfig.style}
                        title={'Serviços e Infra'}
                        visivel={true}
                      ></Legenda> */}
                      </MapView>
                    </div>
                  </div>
                  <div className='painel-lateral col-6 px-5'>
                    <div className='d-flex justify-content-end gap-3 pb-3 pt-5'>
                      <button
                        type='button'
                        className='btn btn-sm btn-light-success'
                        onClick={() => {
                          const el = document.querySelector('#servicos-infra-map')
                          if (el) {
                            exportImage(el, 'mapa-servicos-infra.png')
                          }
                        }}
                      >
                        Salvar mapa PNG
                      </button>
                    </div>
                    <CheckServicesInfra onChange={undefined}></CheckServicesInfra>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
